module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/eb1117630a3be2f65cba86cc2bd06188.png";